import { ArrowUpRight } from "lucide-react";
import { Layout, PageIntro } from "../components/Chrome";
import { MaskedLines, Reveal } from "../components/Motion";
import { campaignExpertise, workedWith } from "../data";

export default function Work() {
  return (
    <Layout>
      <PageIntro
        eyebrow="Brands & campaigns"
        lines={[<>From nano creators</>, <>to <em>regional voices.</em></>]}
        text="We bring brands and creators together through regional campaigns, barter collaborations and influencer partnerships designed around each brand's objectives."
      />
      <section className="brand-showcase section-pad">
        <div className="brand-heading">
          <Reveal as="span" className="eyebrow" y={14}>Brands we’ve worked with</Reveal>
          <MaskedLines as="h2" inView lines={[<>A considered</>, <><em>roster of work.</em></>]} />
          <Reveal as="p" delay={0.2}>A selection of brands across beauty, wellness, fashion, lifestyle, fitness and technology.</Reveal>
        </div>
        <div className="brand-index">
          {workedWith.map((brand, index) => (
            <Reveal className="brand-row" key={brand} delay={(index % 2) * 0.06} y={22} data-testid={`worked-brand-${index + 1}`}>
              <span className="brand-idx">{String(index + 1).padStart(2, "0")}</span>
              <span className="brand-title">{brand}</span>
              <ArrowUpRight className="brand-arrow" size={20} />
            </Reveal>
          ))}
        </div>
      </section>
      <section className="expertise-section">
        <Reveal as="span" className="eyebrow" y={14}>Campaigns & our expertise</Reveal>
        <MaskedLines as="h2" inView lines={[<>Different formats.</>, <>One <em>thoughtful approach.</em></>]} />
        <div className="expertise-grid">
          {campaignExpertise.map(([title, text], index) => (
            <Reveal as="article" className="expertise-card" key={title} delay={index * 0.08} data-testid={`campaign-expertise-${index + 1}`}>
              <span>{`0${index + 1}`}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </Layout>
  );
}
